import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { ns } from '../../styles/navbarStyles';
import { Menu, X } from 'lucide-react';
import logoImg from '../../assets/logo.png';

const Navbar = () => {
  const { logout } = useAuth();
  const [activeSection, setActiveSection] = useState('news');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isScrollingManual = useRef(false);
  
  const OFFSET = 60; 

  const menuItems = useMemo(() => [
    { name: 'Novedades', id: 'news' },
    { name: 'Cronograma', id: 'calendar' },
    { name: 'Operativas', id: 'tutorials' },
    { name: 'Soporte', id: 'support' },
  ], []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;
    
    setIsMenuOpen(false);
    isScrollingManual.current = true;
    setActiveSection(id);
    
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - OFFSET;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    
    setTimeout(() => { isScrollingManual.current = false; }, 1000);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isScrollingManual.current) return;
      
      const scrollPosition = window.scrollY + OFFSET ;
      
      const current = [...menuItems].reverse().find(item => {
        const el = document.getElementById(item.id);
        return el && scrollPosition >= el.offsetTop;
      });

      if (current && current.id !== activeSection) {
        setActiveSection(current.id);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSection, menuItems]);

  return (
    <div className={ns.wrapper}>
      <nav className={ns.nav}>
        <div className="flex items-center gap-4">
          <button className={ns.mobileMenuBtn} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
          <img 
            src={logoImg} 
            alt="MSC" 
            className={ns.logo}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        </div>

        <div className={ns.menuContainer}>
          {menuItems.map((item) => (
            <button 
              key={item.id} 
              onClick={() => scrollToSection(item.id)} 
              className={ns.navBtn(activeSection === item.id)}
            >
              {item.name}
              {activeSection === item.id && <span className={ns.activeIndicator} />}
            </button>
          ))}
        </div>

        {isMenuOpen && (
          <div className={ns.mobileDropdown}>
            {menuItems.map((item) => (
              <button 
                key={item.id} 
                onClick={() => scrollToSection(item.id)} 
                className={ns.mobileNavBtn(activeSection === item.id)}
              >
                {item.name}
              </button>
            ))}
          </div>
        )}

        <div className={ns.logoutContainer}>
          <button onClick={logout} className={ns.logoutBtn}>
            <span className={ns.logoutText}>Salir</span>
            <div className={ns.logoutIconBox}>
              <svg fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
              </svg>
            </div>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;